// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__Lwq6a","col":"styles_col__1BATK"};